module.exports = RGBColor;


//////////////////
// WEBPACK FOOTER
// external "RGBColor"
// module id = 403
// module chunks = 0